import React, { useState } from 'react';
import useAxiosPrivate from '../context/hooks/useAxiosPrivate';
import { Button, Spinner } from 'react-bootstrap';

const ExcelInvoice = ({ invoiceType = 'Cuenta por pagar propia', label }) => {
    const axiosInstance = useAxiosPrivate();
    const [loading, setLoading] = useState(false);

    const handleExport = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`api/financial/export-excel/invoice/?invoice_type=${encodeURIComponent(invoiceType)}`,
                {
                    headers: { 'content-type': 'blob' },
                    responseType: 'arraybuffer',
                    maxRedirects: 2,
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Generate timestamp in YYYYMMDD_HHMMSS format
            const now = new Date();
            const pad = n => n.toString().padStart(2, '0');
            const timestamp = `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

            // Create a link element
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `facturas_${invoiceType.replace(/\s+/g, '_')}_${timestamp}.xlsx`);

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting Excel file:', error);
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {loading ? (
                <Button
                    style={{
                        border: 'solid 2px #024E4C',
                        backgroundColor: '#056664',
                    }}
                    disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    descargando...
                </Button>
            ) : (
                <Button
                    onClick={handleExport}
                    style={{
                        border: 'solid 2px #024E4C',
                        backgroundColor: '#056664',
                    }}
                >
                    {label || `Exportar Excel`}
                </Button>
            )}
        </div>
    );
};

export default ExcelInvoice;
